import { FC, ReactNode } from 'react';

import { useControlAccess } from '@features/auth/hooks/useControlAccess.ts';
import { Permission } from '@shared/consts/permissions';

interface ControlAccessProps {
  requiredPermissions?: Permission[];
  accessDeniedRedirectTo?: string;
  children: ReactNode;
  fallbackView?: ReactNode;
  additionalCondition?: boolean;
}

export const ControlAccess: FC<ControlAccessProps> = ({
  requiredPermissions,
  accessDeniedRedirectTo,
  children,
  fallbackView = null,
  additionalCondition,
}) => {
  const { isUserAllowedToUseResource } = useControlAccess({
    requiredPermissions,
    accessDeniedRedirectTo,
    additionalCondition,
  });

  if (isUserAllowedToUseResource) {
    return children;
  }

  return fallbackView;
};
